import { Children, cloneElement } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import NavItemIcon from "src/components/layout/LayoutCompany/NavItemIcon";
import Link from "src/components/Link";
import useLayout from "src/hooks/useLayout";

interface NavItemProps {
	to?: string;
	onClick?: () => void;
	icon?: string | JSX.Element;
	children?: any;
	className?: string;
	count?: number | null;
	loading?: boolean;
	childItems?: JSX.Element[];
	isChild?: boolean;
}

const NavItem = ({
	to,
	icon,
	children,
	className: _className,
	onClick,
	loading,
	count,
	childItems,
	isChild,
}: NavItemProps) => {
	const { layout } = useLayout();
	const location = useLocation();
	const isActive = to && location.pathname?.includes(to || "");
	let className = `flex flex-col text-white relative bg-transparent transition-all
    cursor-pointer ${_className || ""}`;
	const Element = to ? Link : "div";
	const hasChildItems = !!childItems?.length;

	if (isChild && isActive) {
		className = className.replace("text-white", "text-primary");
	}

	return (
		<Element
			to={to || "/"}
			activeClassName="opacity-100"
			{...{ className, onClick }}
		>
			<div className="flex items-center relative w-full">
				{isActive && !isChild && (
					<div className="w-1 top-0 bottom-0 left-0 bg-primary absolute "></div>
				)}

				<div
					className={`flex items-center hover:opacity-100 gap-3 relative z-20 w-full px-6 py-4 ${
						layout.navbar.variant === "minimal" && "justify-center"
					}`}
				>
					<NavItemIcon {...{ count, icon, loading }} />
					{layout.navbar.variant === "default" && (
						<div className="sm:block md:block lg:hidden flex-1 xl:flex pr-2 font-regular justify-between items-center">
							{children}

							{hasChildItems && (
								<motion.div
									animate={isActive ? "active" : "inactive"}
									variants={{
										inactive: {
											rotate: 0,
										},
										active: {
											rotate: 180,
										},
									}}
								>
									<i className="fas fa-caret-down text-primary"></i>
								</motion.div>
							)}
						</div>
					)}

					{!isChild && (
						<motion.div
							animate={{ opacity: isActive ? 0.15 : 0 }}
							initial={{ opacity: 0 }}
							className="absolute inset-0 bg-primary"
						></motion.div>
					)}
				</div>
			</div>

			{hasChildItems && isActive && (
				<div className="bg-dark-accent">
					{Children.map(childItems, (child: any) =>
						cloneElement(child, {
							isChild: true,
						})
					)}
				</div>
			)}
		</Element>
	);
};

export default NavItem;
